export function initGlobalBackground(canvasId: string): void {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d')!;
    const DPR = Math.min(window.devicePixelRatio || 1, 2);

    let width = 0;
    let height = 0;
    const particles: Particle[] = [];
    const particleCount = Math.min(Math.floor((window.innerWidth * window.innerHeight) / 15000), 120);
    
    // Brand Accent Color: #ed2939 -> rgb(237, 41, 57)
    const COLOR = '237, 41, 57';

    class Particle {
        x: number = Math.random() * window.innerWidth;
        y: number = Math.random() * window.innerHeight;
        vx: number = (Math.random() - 0.5) * 0.4;
        vy: number = (Math.random() - 0.5) * 0.4;
        size: number = Math.random() * 1.5 + 0.5;
        pulse: number = Math.random() * Math.PI;

        update() {
            this.x += this.vx;
            this.y += this.vy;
            this.pulse += 0.02;

            if (this.x < 0 || this.x > width) this.vx *= -1;
            if (this.y < 0 || this.y > height) this.vy *= -1;
        }

        draw() {
            const opacity = 0.05 + Math.sin(this.pulse) * 0.1;
            ctx.fillStyle = `rgba(${COLOR}, ${opacity})`;
            ctx.beginPath();
            ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
            ctx.fill();
        }
    }

    function resize() {
        width = canvas.width = window.innerWidth * DPR;
        height = canvas.height = window.innerHeight * DPR;
        ctx.scale(DPR, DPR);
        width = window.innerWidth;
        height = window.innerHeight;
    }

    function init() {
        resize();
        particles.length = 0;
        for (let i = 0; i < particleCount; i++) {
            particles.push(new Particle());
        }
    }

    function animate() {
        ctx.clearRect(0, 0, width, height);
        
        particles.forEach((p, i) => {
            p.update();
            p.draw();

            for (let j = i + 1; j < particles.length; j++) {
                const p2 = particles[j];
                const dx = p.x - p2.x;
                const dy = p.y - p2.y;
                const dist = Math.hypot(dx, dy);

                if (dist < 180) {
                    const alpha = (1 - dist / 180) * 0.12;
                    ctx.strokeStyle = `rgba(${COLOR}, ${alpha})`;
                    ctx.lineWidth = 0.5;
                    ctx.beginPath();
                    ctx.moveTo(p.x, p.y);
                    ctx.lineTo(p2.x, p2.y);
                    ctx.stroke();
                }
            }
        });

        requestAnimationFrame(animate);
    }

    window.addEventListener('resize', () => {
        resize();
    });

    init();
    animate();
}
